import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListArriveLateConfigStart,
  getListArriveLateConfigSuccess,
  getListArriveLateConfigFailed,
} from "../redux/getListArriveLateConfig";
import moment from "moment";
import { getListArriveLateConfigApi } from "core/http/service/timeKeeping";
import { formReqUpdateDetailFormArriveLate } from "../redux/formReqArrivingLateLeaveEarly";
import { selectFormReqArrivingLateLeaveEarly } from "../redux/selector";
import { ReqType } from "../components/CustomCalendarTimeKeeping/components/ArrivingLateLeavingEarly";

function* getListArriveLateConfigWork(action) {
  const { screenCode, ...payload } = action.payload;
  const { data } = yield select(selectFormReqArrivingLateLeaveEarly);
  try {
    const res = yield call(getListArriveLateConfigApi, screenCode, {
      ...payload,
    });

    const formattedData = res
      .map((item, index) => ({
        ...item,
        index: index + 1,
        fromDate: moment(item?.fromDate),
        toDate: moment(item?.toDate),
        defaultSelected:
          item?.lateReasonCode && item?.earlyReasonCode
            ? ""
            : item?.lateReasonCode
              ? ReqType.ArrivingLate
              : ReqType.LeavingEarly,
      }))
      .concat([...data.details]?.filter((item) => item?.isNew));

    yield put({
      type: getListArriveLateConfigSuccess.type,
      payload: formattedData,
    });
    yield put({
      type: formReqUpdateDetailFormArriveLate.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListArriveLateConfigFailed.type,
    });
  }
}

function* watchGetListArriveLateConfig() {
  yield takeLatest(
    getListArriveLateConfigStart.type,
    getListArriveLateConfigWork
  );
}

export default function* getListArriveLateConfigSaga() {
  yield all([watchGetListArriveLateConfig()]);
}
